import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThreeDotsMenuComponent } from '@shared/components/three-dots-menu/three-dots-menu.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [
    ThreeDotsMenuComponent
  ],
  imports: [
    CommonModule,
    MatMenuModule,
    MatIconModule
  ],
  exports: [
    ThreeDotsMenuComponent
  ]
})
export class ThreeDotsMenuModule { }
